import React, { Component } from "react";
import { Route, Routes } from "react-router-dom";
import AdminLayout from "./AdminLayout";
import AdminDashboard from "./AdminDashboard";
import AdminUserPermissionChanger from "./AdminUserPermissionChanger";
import Upload from "./Upload";
import CreateDepartments from "./CreateDepartments";
import ChatTrackerHome from "./ChatTracker/ChatTrackerHome";
import ConversationDetail from "./ChatTracker/ConversationDetail";
import ChatTrackerAnalytics from "./ChatTracker/ChatTrackerAnalytics";
import ChatTrackerSettings from "./ChatTracker/ChatTrackerSettings";

class AdminRoutes extends Component {
  render() {
    return (
      <Routes>
        <Route element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="upload" element={<Upload />} />
          <Route path="create-department" element={<CreateDepartments />} />
          <Route path="chat-tracker" element={<ChatTrackerHome />} />
          <Route
            path="chat-tracker/conversation/:id"
            element={<ConversationDetail />}
          />
          <Route
            path="chat-tracker/analytics"
            element={<ChatTrackerAnalytics />}
          />
          <Route
            path="chat-tracker/settings"
            element={<ChatTrackerSettings />}
          />
          <Route path=":id" element={<AdminUserPermissionChanger />} />
        </Route>
      </Routes>
    );
  }
}

export default AdminRoutes;
